import { Accordion } from '@components/HomePage/FAQ/Accordion';
import React from 'react';
import { CtaBtn } from '@components/LandingElements/CtaBtn';

/**
 * @param {{question: string, answer: string}[]} content
 * @param ctaLink href for CTA button
 * @param ctaText text for CTA button
 */
export const SimpleFaq = ({ content, ctaLink, ctaText }) => {
  return (
    <section className="px-[20px] w-full max-w-screen-md mx-auto">
      <header className="mb-[48px]">
        <h2 className="text-center text-30px leading-[40px] font-bold mt-0 mb-[32px]">
          Questions & Answers
        </h2>
      </header>

      <Accordion items={content} />

      <section className="flex flex-col items-center pt-[24px]">
        <CtaBtn href={ctaLink} text={ctaText} />
      </section>
    </section>
  );
};
